import React from "react";
import IconButtonWrapper from "../../../../../views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { ReactComponent as QuestionIcon } from "assets/img/svg/QuestionMarkConfirmationDialog.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "../../../../../views/pages/manage/common/form-fields-mui/AButton";
import { useRevokeCheque } from "../hooks/useUpdateChequeStatus";
import ALoader from "../../../../../views/pages/manage/common/a-loader";
import { failureToast } from "../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function";
const RevokeConfirmation = ({ handleClose, row, refreshList ,state, setState}) => {
  const { revokeCheque, isLoading, error } = useRevokeCheque();

  const handleRevoke = () => {
    const { psid, referenceNumber } = row;
    if (!psid || !referenceNumber) {
      failureToast("Missing required cheque information.");
      return;
    }

    const refreshListHandler = () => {
      refreshList({}, {}, "REVOKE");
    }
    const requestPayload = {
      psid,
      referenceNumber,
    };
    revokeCheque(requestPayload, refreshListHandler,()=>{}, state, setState);
  };

  return (
    <div style={{ padding: "28px 24px", width: "500px" }}>
      <>
        {" "}
        {isLoading && <ALoader position={"fixed"} />}
        <div className="heading-4 color-dark mb-4">
          Are you sure you want to revoke this cheque?
        </div>
      </>

      <div className="d-flex justify-content-between mt-1">
        <AButton
          variant="outline"
          className="button_remove_left_margin"
          updatedStyle={{
            border: "1px solid #414141",
            color: "#414141",
            width: "180px",
          }}
          onClick={handleClose}
        >
          No
        </AButton>
        <AButton
          variant="danger_filled"
          updatedStyle={{ backgroundColor: "#CC5F5F", width: "180px" }}
          onClick={() => {
            handleRevoke();
            handleClose();
          }}
        >
          Yes
        </AButton>
      </div>
    </div>
  );
};

export default RevokeConfirmation;
